
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup(_, { emit }) {
    const testImage = ref<any[]>([]);

    const emitImageData = () => {
      emit("dispatchImage", testImage.value);
    };

    const onImageUploaded = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const images = target.files as FileList;

      if (images.length > 1) {
        for (let key = 0; key < images.length; key++) {
          testImage.value.push(images[key]);
        }
      } else {
        testImage.value.push(images[0]);
      }

      emitImageData();

      testImage.value = [];
    };

    return {
      testImage,
      onImageUploaded,
      emitImageData,
    };
  },
});
